import React from "react";
import { ASSETS_URL } from "../../utils/config";
import moment from "moment";

const PeopleCard = ({ leader, showClockIcon = false }: any) => {
  return (
    <div
      key={leader.id}
      className="bg-white rounded-2xl sm:rounded-3xl transition-all duration-300 transform hover:-translate-y-1 sm:hover:-translate-y-2 xl:border-r-8 lg:border-r-8 sm:border-r-6 md:border-r-8 border-b-4 sm:border-b-6 md:border-b-8 border-navgreen overflow-visible shadow-[0px_0px_4px_0px_#00000040] hover:shadow-xl w-full h-auto min-w-0"
    >
      <div className="p-3 xs:p-4 sm:p-5 md:p-6 lg:p-5 xl:p-6 text-center h-full flex flex-col justify-between">
        {/* Profile Image */}
        <div className="relative mb-2 sm:mb-2 lg:mb-1 xl:mb-2">
          <div className="w-16 h-16 xs:w-20 xs:h-20 sm:w-24 sm:h-24 md:w-28 md:h-28 lg:w-24 lg:h-24 xl:w-28 xl:h-28 mx-auto rounded-full overflow-hidden">
            <img
                src={`${ASSETS_URL}${leader?.profilePic}`}
              alt={leader.name}
              className="h-full w-full object-cover"
              onError={(e) => {
                const target = e.target as HTMLImageElement;
                target.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(
                  leader.name
                )}&background=22c55e&color=ffffff&size=128&font-size=0.5`;
              }}
            />
          </div>
        </div>

        {/* Leader Info */}
        <div className="space-y-2 sm:space-y-3 lg:space-y-2 xl:space-y-2 flex flex-col items-center justify-center text-center">
          {/* Name */}
          <p className="text-xs xs:text-sm sm:text-xl md:text-xl lg:text-lg xl:text-xl font-semibold text-black break-words overflow-hidden leading-tight text-center">
            {leader.name}
          </p>

          {/* Position */}
          <p className="text-xs xs:text-xs sm:text-sm md:text-base lg:text-xs xl:text-base font-medium text-deepTeal break-words overflow-hidden leading-tight text-center px-1">
          {leader.designation}
          </p>
          {/* <p className="text-xs xs:text-xs sm:text-sm md:text-base lg:text-xs xl:text-base font-medium text-deepTeal break-words overflow-hidden leading-tight text-center px-1">
          {leader.address}
          </p> */}

          {/* <p className="text-xs sm:text-sm md:text-base lg:text-xs xl:text-base px-2 sm:px-3 lg:px-0 xl:px-3 font-medium text-deepTeal space-x-3 flex items-center justify-center">
            <span>

              {showClockIcon && (
                <img
                  src="assets/Clock.svg"
                  alt="Experience"
                  className="h-4 w-4 sm:h-5 sm:w-5 flex-shrink-0"
                />
              )}
            </span>
            <span>

              {leader.promotedAs}
            </span>
          </p> */}

          {/* Moved To */}
          <p className="text-xs xs:text-xs sm:text-sm md:text-base lg:text-xs xl:text-base font-medium text-deepTeal break-words overflow-hidden leading-tight text-center px-1">
            {leader.moveDescription}
          </p>

          {/* Effective Date */}
          <p className="text-xs xs:text-xs sm:text-sm md:text-base lg:text-xs xl:text-base font-medium text-deepTeal break-words overflow-hidden leading-tight text-center px-1">
            {moment(leader.moveEffectiveDate).format('DD-MM-YYYY')}
          </p>
        </div>
      </div>
    </div>
  );
};

export default PeopleCard;